import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Card , Typography} from '@mui/material';
import axios from 'axios';
import 'lightbox2/dist/css/lightbox.css';
import 'lightbox2/dist/js/lightbox.js';
import '../components/styles/lightbox-custom.css'; // Import your custom
import BASE_URL from '../config';
const ThumbnailGallery = () => {
  const { albumId } = useParams();
  const [thumbnails, setThumbnails] = useState([]);
  const [albumName, setAlbumName] = useState('');
// Fetch thumbnails and album name
useEffect(() => {
  const fetchAlbumData = async () => {
    try {
      const [thumbnailResponse, albumResponse] = await Promise.all([
        axios.get(`${BASE_URL}/api/albums/${albumId}/thumbnails`),
        axios.get(`${BASE_URL}/api/albums/${albumId}`)
      ]);
      setThumbnails(thumbnailResponse.data);
      setAlbumName(albumResponse.data.album_name);
    } catch (error) {
      console.error('Error fetching album data:', error);
    }
  };
  fetchAlbumData();
}, [albumId]);
  /* useEffect(() => {
    // Initialize Colorbox using window.$
    if (thumbnails.length > 0 && window.$) {
      window.$('.thumbnail-link').colorbox({
        rel: 'gallery',
        slideshow: true,
        slideshowSpeed: 3000,
        transition: 'fade',
        width: '95%',
        height: '95%',
         scalePhotos: true,
        photo: true,
        closeButton: true,
        current: 'Image {current} of {total}',
        previous: 'Previous',
        next: 'Next',
      });
    }
  }, [thumbnails]); */
  useEffect(() => {
  if (thumbnails.length > 0 && window.$) {
    window.$('.thumbnail-link').colorbox({
      rel: 'gallery',
      slideshow: true,
      slideshowSpeed: 3000,
      transition: 'fade',

      maxWidth: '95%',
      maxHeight: '95%',

      scalePhotos: true,
      photo: true,
      fixed: true,

      current: 'Image {current} of {total}',
      previous: 'Previous',
      next: 'Next',
      close: 'Close',

      onComplete: function () {
        // Force image container styling
        window.$('#cboxLoadedContent img').css({
          width: 'auto',
          height: 'auto',
          'max-width': '100%',
          'max-height': '85vh',
          'object-fit': 'contain',
          display: 'block',
          margin: '0 auto',
          'border-radius': '10px'
        });

        // Force popup box size
        window.$('#colorbox').css({
          width: '90%',
          height: '90%'
        });

        window.$('#cboxContent').css({
          height: '100%',
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          overflow: 'hidden',
          background: '#000'
        });
      }
    });
  }
}, [thumbnails]);
  return (
    <div style={{ padding: '20px' }}>
    {/* Album Name Display */}
    <Typography
      variant="h4"
      align="center"
      gutterBottom
      style={{
        fontWeight: 'bold',
        color: '#1976d2',
        textTransform: 'uppercase',
        fontStyle: 'italic',
      }}
    >
      {albumName}
    </Typography>
    <Grid
    container
    spacing={2}
    style={{
      marginTop: '20px',
      padding: '10px',
    }}
  >
    {thumbnails.map((thumbnail, index) => {
      // Extract the file name from the thumbnail path
      return (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
          <Card style={{ padding: '8px' }}>
            <div
              style={{
                width: '100%',
                height: '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderRadius: '8px',
                backgroundColor: '#f0f0f0',
              }}
            >
              {/* Link to full-size image using only the file name */}
              <a
                //href={`${BASE_URL}/uploads/photo_gallery${thumbnail}`}
                //href={`${BASE_URL}${thumbnail}`}
                 href={`${BASE_URL}${thumbnail.replace('/thumbnails/', '/photo_gallery/')}`}
                data-lightbox="gallery"
                data-title={`Image ${index + 1}`}
                className="thumbnail-link"
              >
                <img
                  //src={`${BASE_URL}/uploads/thumbnails${thumbnail}`}
                  src={`${BASE_URL}${thumbnail}`}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                    cursor: 'pointer',
                  }}
                />
              </a>
            </div>
          </Card>
        </Grid>
        
      );
    })}
  </Grid>
</div>
  );
};
export default ThumbnailGallery;
